/**
 * @module lib/validate
 * Utils for basic input validation.
 */

import moment from "moment";

/**
 * Check if the given string is empty.
 * Whitespace counst as empty.
 */
export function isStringEmpty(string) {
  return string.trim().length === 0;
}

/**
 * Check if two strings are the same.
 * Ignores case and leading/trailing whitespace.
 */
export function doStringsMatch(string1, string2) {
  return string1.trim().toLowerCase() === string2.trim().toLowerCase();
}

/**
 * Check if given product is going through maintainenace/downtime
 */
export function isProductAvailable(product) {
  const currentDateTime = new moment();
  if(product === "school_money") {
    if(currentDateTime >= new moment(process.env.REACT_APP_SCHOOLMONEY_DOWN_TIME_START) && currentDateTime <= new moment(process.env.REACT_APP_SCHOOLMONEY_DOWN_TIME_END)) {
      return false;
    }
  } else if(product === "teachers") {
    if(currentDateTime >= new moment(process.env.REACT_APP_TEACHERS2PARENTS_DOWN_TIME_START) && currentDateTime <= new moment(process.env.REACT_APP_TEACHERS2PARENTS_DOWN_TIME_END)) {
      return false;
    }
  }
  return true;
}

/**
 * Check if appserver is available
 */
export function isAppserverOnline() {
  const currentDateTime = new moment();
  if(currentDateTime >= new moment(process.env.REACT_APP_EDUSPOT_DOWN_TIME_START) && currentDateTime <= new moment(process.env.REACT_APP_EDUSPOT_DOWN_TIME_END)) {
    return false;
  }
  return true;
}

/**
 * Checks if given path has one of valid extentions
 */
export function isLogoPathValid(path) {
  const validExtentionList = [".jpg", ".jpeg", ".gif", ".png"];
  return validExtentionList.some(element => {
    return path.endsWith(element);
  });
};

/**
 * Check if the given time is past the current time
 */
export function hasTimePassed(giveDate) {
  const currentDateTime = new moment();
  if(currentDateTime > new moment(giveDate)) {
    return true;
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/lib/validate/index.js